import { Recipes } from '@cookspace-shared-contracts/core';

import { baseApi } from '@/api/baseApi';
import { parseWithSchema } from '@/lib/safeParse';

/**
 * RTK Query endpoints для admin-backend /recipes/*.
 * Read-only режим: list (всех статусов) и get details.
 * admin-backend на порту 5002 без префикса /admin.
 */
export const recipesApi = baseApi.injectEndpoints({
    endpoints: (build) => ({
        listRecipes: build.query<
            Recipes.GetRecipesResponse,
            Recipes.GetRecipesRequest | void
        >({
            query: (params) => {
                const search: Record<string, string> = {};
                if (params?.search) {
                    search.search = params.search;
                }
                if (params?.categoryId) {
                    search.categoryId = params.categoryId;
                }
                if (params?.difficulty) {
                    search.difficulty = params.difficulty;
                }
                if (params?.isPremium !== undefined) {
                    search.isPremium = params.isPremium ? 'true' : 'false';
                }
                if (params?.isUserContent !== undefined) {
                    search.isUserContent = params.isUserContent ? 'true' : 'false';
                }
                if (params?.authorId) {
                    search.authorId = params.authorId;
                }
                if (params?.limit !== undefined) {
                    search.limit = String(params.limit);
                }
                if (params?.offset !== undefined) {
                    search.offset = String(params.offset);
                }
                return {
                    url: '/recipes',
                    method: 'GET',
                    params: search
                };
            },
            transformResponse: (raw: unknown): Recipes.GetRecipesResponse =>
                parseWithSchema(Recipes.GetRecipesResponseSchema, raw),
            providesTags: (result) =>
                result
                    ? [
                        ...result.items.map((r) => ({
                            type: 'Recipe' as const,
                            id: r.id
                        })),
                        { type: 'Recipe' as const, id: 'LIST' }
                    ]
                    : [{ type: 'Recipe' as const, id: 'LIST' }]
        }),

        getRecipe: build.query<Recipes.GetRecipeResponse, { id: string }>({
            query: ({ id }) => ({
                url: `/recipes/${id}`,
                method: 'GET'
            }),
            transformResponse: (raw: unknown): Recipes.GetRecipeResponse =>
                parseWithSchema(Recipes.GetRecipeResponseSchema, raw),
            providesTags: (_result, _error, arg) => [{ type: 'Recipe', id: arg.id }]
        })
    })
});

export const { useListRecipesQuery, useGetRecipeQuery } = recipesApi;
